import React from "react";
import { Divider } from "@chakra-ui/react";
import { Clock, Star } from "lucide-react";
import type { MarriageProfileDto } from "src/types/Profile";
import type { AstroDetails } from "src/types/matrimonyProfileDetails";
import { formatTimeHHMM } from "src/utils/matrimonyOptions";
import AstroRow from "../AstroRow";
import InfoCard from "../InfoCard";
import EditButton from "../EditButton";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import { DOSHAM_OPTIONS, getOptionLabel } from "src/utils/matrimonyOptions";

type AstroSectionProps = {
  astro: AstroDetails;
  dto: MarriageProfileDto;
  isOwnProfile: boolean;
  onEdit: () => void;
};

const AstroSection: React.FC<AstroSectionProps> = ({ astro, dto, isOwnProfile, onEdit }) => (
  <InfoCard
    title="Astro Details"
    icon={<Star size={18} />}
    rightSlot={isOwnProfile ? <EditButton onClick={onEdit} /> : null}
  >
    <AstroRow label={FIELD_LABELS.RASI} value={astro.rasi} icon={<Star size={16} />} />
    <Divider borderColor="#EFE7E7" />
    <AstroRow label={FIELD_LABELS.NAKSHATRA} value={astro.nakshatra} icon={<Star size={16} />} />
    <Divider borderColor="#EFE7E7" />
    <AstroRow label={FIELD_LABELS.DOSHAM} value={getOptionLabel(DOSHAM_OPTIONS, dto.dosham)} icon={<Star size={16} />} />
    <Divider borderColor="#EFE7E7" />
    <AstroRow label={FIELD_LABELS.GOTHRAM} value={dto.gothram || ""} icon={<Star size={16} />} />
    <Divider borderColor="#EFE7E7" />
    <AstroRow label={FIELD_LABELS.TIME_OF_BIRTH} value={formatTimeHHMM(dto.timeOfBirth)} icon={<Clock size={16} />} />
  </InfoCard>
);

export default AstroSection;
